import { Section } from 'components/section'
import { Heading } from 'components/heading'
import { Markdown } from 'components/markdown'

import classes from './easy-to-implement.module.css'
import { MAIN_TEXT } from './consts'
import { Steps } from './Steps'

export const EasyToEmplement = () => {
  return (
    <Section className={classes.section}>
      <Heading theme="h2" className={classes.title}>
        Easy to implement price protection in your sales process
      </Heading>
      <Markdown className={classes.mainText}>{MAIN_TEXT}</Markdown>
      <Steps />
    </Section>
  )
}
